import { Link } from "react-router-dom";
import about1 from "../assets/about1.jpg";
import about2 from "../assets/about2.jpeg";
import card1 from "../assets/profile.jpeg";

const About = () => {
  return (
    <section className="bg-[#fff9e6] py-24">
      <div className="max-w-7xl mx-auto px-6">

        {/* ================= ABOUT ME SECTION ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center mb-32">

          {/* Image */}
          <div className="border-4 border-[#8a8a00] rounded-2xl overflow-hidden">
            <img
              src={card1}
              alt="meenakshi"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text */}
          <div>
            <h2 className="text-5xl font-serif text-[#8b6c8d] mb-6">
              about me
            </h2>

            <p className="text-[#7a7a00] text-lg mb-6">
              Hiii, I’m Meenakshi!
            </p>

            <p className="text-[#7a7a00] text-lg leading-relaxed mb-6">
              I’m the recipe developer and content creator behind everything
              you see here on meenakshi kooks and I’m so excited to have you here!
            </p>

            <p className="text-[#7a7a00] text-lg leading-relaxed">
              About 4 months ago, two things happened, I welcomed my dog Kookie into my life (I'm a tiny bit obsessed with her) and started experimenting in the kitchen. As an introvert, putting myself
              out there was tough but Kookie somehow gave me the push I needed.
              The name “meenakshi kooks” – it’s special to me. “kooks” is a playful
              nod to both Kookie and cooking. It represents my two great loves
              coming together in this blog!
            </p>
          </div>
        </div>

        {/* ================= FAV RECIPES SECTION ================= */}
        <div>
          <h3 className="text-4xl font-serif text-[#8a8a00] mb-12">
            my all time FAV recipes:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-3xl">

            {/* Card 1 */}
            <Link
              to="/recipes"
              className="bg-[#b46a6d] rounded-2xl overflow-hidden"
            >
              <img
                src={about1}
                alt="Chocolate Chip Cookie"
                className="w-full h-80 object-cover"
              />
              <div className="p-5 text-center">
                <p className="text-white font-serif text-lg">
                  Single Serve Chocolate Chip Cookie
                </p>
              </div>
            </Link>

            {/* Card 2 */}
            <Link
              to="/recipes"
              className="bg-[#b46a6d] rounded-2xl overflow-hidden"
            >
              <img
                src={about2}
                alt="Red Velvet Cookie"
                className="w-full h-80 object-cover"
              />
              <div className="p-5 text-center">
                <p className="text-white font-serif text-lg">
                  Single Serve Red Velvet Cookie
                </p>
              </div>
            </Link>

          </div>
        </div>

      </div>
    </section>
  );
};

export default About;
